<template>
    <div class="example-month">
        <div class="example-header">
            <div class="example-title">A typical Pro month</div>
            <div class="example-budget">
                <strong>{{ data.credits_total }} credits</strong> ·
                <strong>{{ formatNumber( data.tokens_total ) }} tokens</strong>
            </div>
        </div>

        <div class="example-grid">
            <a
                v-for="(item, i) in rows"
                :key="item.slug || i"
                :href="productUrl( item.slug )"
                class="toolkit-row"
            >
                <div class="toolkit-emoji" :style="{ background: gradientFor( item, i ) }">
                    <img v-if="item.image_thumb" :src="item.image_thumb" :alt="item.name">
                    <template v-else>{{ item.emoji }}</template>
                </div>
                <div class="toolkit-info">
                    <div class="toolkit-name">{{ item.name }}</div>
                    <div class="toolkit-tag">{{ item.category_name }}</div>
                </div>
                <div class="toolkit-cost">${{ item.credits }}</div>
            </a>
        </div>

        <div class="example-footer">
            <div class="example-total">
                <strong>{{ rows.length }} toolkits · {{ creditsUsed }} credits used</strong>
            </div>
            <div class="example-leftover">{{ creditsLeft }} credits still available</div>
        </div>
        <div class="example-catalog-note">…and {{ data.total_products }} more toolkits in your catalog</div>
    </div>
</template>

<script>
// Фолбэк-градиенты для товаров без category_gradient — ротация по индексу.
const GRADIENTS = [
    'linear-gradient(135deg, #ec4899, #f472b6)',
    'linear-gradient(135deg, #3b82f6, #8b5cf6)',
    'linear-gradient(135deg, #84cc16, #65a30d)',
    'linear-gradient(135deg, #eab308, #fbbf24)',
    'linear-gradient(135deg, #06b6d4, #3b82f6)',
    'linear-gradient(135deg, #f97316, #fb923c)',
];

function toCredits( item ) {
    const cents = Number( item.sale_price ) || Number( item.price ) || 0;

    return Math.round( cents / 100 );
}

export default {
    name: 'Pricing',

    props: {
        data:    { type: Object, required: true },
        homeUrl: { type: String, default: '' },
    },

    computed: {
        // Карточки из product_query + посчитанные кредиты, упорядоченные по
        // встроенной сортировке коллекции (data.order = порядок product_ids).
        rows() {
            const order = ( this.data.order || [] ).map( Number );

            const items = ( this.data.items || [] ).map( item => ({
                ...item,
                credits: toCredits( item ),
            }) );

            const sorted = order.length
                ? items.slice().sort(
                    ( a, b ) => order.indexOf( Number( a.id ) ) - order.indexOf( Number( b.id ) )
                )
                : items;

            const limit = Number( this.data.limit ) || 0;

            return limit > 0 ? sorted.slice( 0, limit ) : sorted;
        },
        creditsUsed() {
            return this.rows.reduce( ( sum, r ) => sum + r.credits, 0 );
        },
        creditsLeft() {
            return Math.max( 0, Number( this.data.credits_total || 0 ) - this.creditsUsed );
        },
    },

    methods: {
        productUrl( slug ) {
            return `${ this.homeUrl }/product/${ slug }`;
        },
        gradientFor( item, i ) {
            return item.category_gradient || GRADIENTS[ i % GRADIENTS.length ];
        },
        formatNumber( n ) {
            return Number( n || 0 ).toLocaleString( 'en-US' );
        },
    },
};
</script>
